module.exports = __webpack_public_path__ + "static/media/Health.2474275a.svg";